import React from 'react';
import { Box, Container, Typography, Link as MuiLink, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

export default function StorefrontFooter() {
  return (
    <Box sx={{ background: '#1a2332', color: '#fff', pt: 6, pb: 3, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Box
                component="img"
                src="https://figk-12.com/static/media/fig_CROP.cb0d7cf4314c63ba05ee.png"
                alt="FIG"
                sx={{ height: 36 }}
              />
              <Typography variant="h6" sx={{ fontWeight: 700 }}>Marketplace</Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', maxWidth: 300 }}>
              Quality products for K-12 education. Trusted by schools and districts nationwide.
            </Typography>
          </Grid>
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>Shop</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink component={Link} to="/products" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', '&:hover': { color: '#fff' } }}>All Products</MuiLink>
              <MuiLink component={Link} to="/cart" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', '&:hover': { color: '#fff' } }}>Cart</MuiLink>
            </Box>
          </Grid>
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>Company</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <MuiLink href="https://figk-12.com" target="_blank" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', '&:hover': { color: '#fff' } }}>FIG K-12</MuiLink>
              <MuiLink href="https://sales.figk-12.com" target="_blank" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem', '&:hover': { color: '#fff' } }}>Sales Portal</MuiLink>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', pt: 3, textAlign: 'center' }}>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)' }}>
            &copy; {new Date().getFullYear()} FIG K-12. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
